(function ($) {
    $(document).ready(function() {
        var CODE = "US";

        var countryCode = getCookie('country_code'),
            geoIp = theme.geoIp;
        CODE = theme.geoIpRegion;

        function handleResponse(response) {
            var locationCountryCode = response.country_code2;
            locationCountryCode = typeof locationCountryCode !== 'undefined'
                ? locationCountryCode : CODE;
            setCookie('country_code', locationCountryCode, 1, 0);
            prepareContent(locationCountryCode);
        }

        function setCookie(cname, cvalue, exdays, exhours) {
            var d = new Date();

            if (exdays == 0 && exhours > 0) {
                d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
            } else {
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            }

            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
            var name = cname + "=";
            var urlValue = encodeURI(document.cookie);
            var decodedCookie = decodeURIComponent(urlValue);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        function prepareContent(location) {
            if (location != 'US') {
                var locale = getQueryVariable('locale');
                if (locale !== false && locale.toLowerCase() == 'en-us') {
                    location = 'US';
                }
            }
            if (location != 'US') {
                checkRedirect('US');
                if(location == 'CA' && CODE == 'CAN') {
                    $('.INTL').remove();
                    $('.US').css('display', 'flex');
                    $('.US').show();
                    $('.CAN').css('display', 'flex');
                    $('.CAN').show();
                } else if (location == 'CA' && CODE == 'US'){
                    $('.US').hide();
                    $('.CAN').css('display', 'flex');
                    $('.CAN').show();
                    $('.INTL').css('display', 'flex');
                    $('.INTL').show();
                } else {
                    $('.US').remove();
                    $('.CAN').remove();
                    $('.INTL').css('display', 'flex');
                    $('.INTL').show();
                }
                const no_us_buttons = document.querySelectorAll('[data-no-us]');
                if (no_us_buttons) {
                    no_us_buttons.forEach((el) => {
                        el.innerHTML = el.getAttribute('data-no-us');
                    })
                }

                const no_us_link = document.querySelector('[data-no-us-link]');
                if (no_us_link) no_us_link.setAttribute('href', no_us_link.getAttribute('data-no-us-link'));
            } else {
                checkRedirect('INTL');
                $('.INTL').remove();
                $('.CAN').hide();
                $('.US').css('display', 'flex');
                $('.US').show();
            }

            var css = (location != 'US' ? location === 'CA' ? '.US' : '.CAN, .US': '.INTL, .CAN') + ' { display: none!important; }',
                head = document.head || document.getElementsByTagName('head')[0],
                style = document.createElement('style');

            if (location === 'US') {
                css += '.collection-page .collection__content .US { display: flex; }';
                css += '.header__menu .US { display: block !important;}';
                css += '.ve-container-box { display: block !important;}';
            } else if (location === 'CA') {
                css += '.collection-page .collection__content .CAN { display: flex; }';
                css += '.header__menu .CAN { display: block !important;}';
            } else {
                css += '.collection-page .collection__content .INTL { display: flex; }';
                css += '.header__menu .INTL { display: block !important;}';
            }

            head.appendChild(style);
            style.type = 'text/css';
            if (style.styleSheet) {
                style.styleSheet.cssText = css;
            } else {
                style.appendChild(document.createTextNode(css));
            }
        }


        if (geoIp === true) {
            prepareContent(CODE);
        } else if (typeof countryCode !== 'undefined' && countryCode !== '') {
            prepareContent(countryCode);
        } else {
            var locale = getQueryVariable('locale');
            if (locale) {
                var localeParts = locale.split('-');
                if (localeParts.length > 1) {
                    var localeCountry = localeParts[1].toUpperCase();
                    setCookie('country_code', localeCountry, 1, 0);
                    prepareContent(localeCountry);

                    return;
                }
            }

            getGeolocation(handleResponse.bind(this), "777608e6815044638f77282af81528db");
        }

        function checkRedirect(className) {
            var element = $('.redirect-check');
            if (element.length) {
                var url = element.data('url');
                url = typeof url == "undefined" || url == '' ? '/' : url;
                if (element.hasClass(className)) {
                    window.location.href = url;
                }
            }
        }

        function getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
            return (false);
        }
    });
})(jQuery);
